import React, { useEffect, useRef, useState } from 'react'


import styles from '../../css/style.module.css'


import HOC from '../../components/HOC/HOC'
import { Link, useNavigate } from 'react-router-dom';
import { SuccessfullyModal } from '../../components/Modals/Modals';
import {  getApi, putApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

import img2 from '../../assest/loading1.gif'
import { RiImageAddLine } from "react-icons/ri";



const UserContactDetails = () => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false)

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [mobilenumber, setMoileNumber] = useState('');
    const [fb, setFB] = useState("")
    const [insta, setInsta] = useState('');
    const [linkdin, setLinkdin] = useState('');
    const [twitter, setTwitter] = useState('');
    const [mobilenumberdescription, setMobileDescription] = useState('');
    const [email, setEmail] = useState('');
    const [emaildescription, setEmailDescription] = useState('');
    const [whatsappnumber, setWhatsappNumeber] = useState('')
    const [map, setMap] = useState('');
    const [address, setAddress] = useState('');
    const [id, setId] = useState('');
    const [whatsappdescription, setWhatsappdescription] = useState('')

    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const fileInputRef = useRef(null);


    const fetchData = async () => {
        await getApi(endPoints.getContactDetails('user'), {
            setResponse: (response) => {
                setTitle(response?.data?.title || '');
                setDescription(response?.data?.description || '');
                setMoileNumber(response?.data?.mobileNumber || '');
                setFB(response?.data?.fb || '');
                setInsta(response?.data?.instagram || '');
                setLinkdin(response?.data?.linkedIn || '');
                setTwitter(response?.data?.twitter || '');
                setMobileDescription(response?.data?.mobileNumberDescription || '');
                setEmail(response?.data?.email || '');
                setEmailDescription(response?.data?.emailDescription || '');
                setWhatsappNumeber(response?.data?.whatAppchat || '');
                setWhatsappdescription(response?.data?.whatAppchatDescription || '');
                setAddress(response?.data?.address || '');
                setMap(response?.data?.map || '');
                setId(response?.data?._id || '');
                if (response?.data?.image) {
                    setImagePreview(response?.data?.image); // Set the image preview if data has an image URL
                }
            },
            setLoading,
            errorMsg: 'Failed to fetch data!',
        });
    };


    useEffect(() => {
        fetchData();
    }, [])


    const handleUpdate = async () => {
        const formData = new FormData();
        formData.append('title', title);
        formData.append('description', description);
        formData.append('mobileNumber', mobilenumber);
        formData.append('fb', fb);
        formData.append('instagram', insta);
        formData.append('linkedIn', linkdin);
        formData.append('twitter', twitter);
        formData.append('mobileNumberDescription', mobilenumberdescription);
        formData.append('email', email);
        formData.append('emailDescription', emaildescription);
        formData.append('whatAppchat', whatsappnumber);
        formData.append('whatAppchatDescription', whatsappdescription);
        formData.append('address', address);
        formData.append('map', map);
        formData.append('image', image);

        await putApi(endPoints.updatecontactdetails(id), formData, {
            setLoading,
            successMsg: 'Contact Details updated successfully!',
            errorMsg: 'Failed to update contact Details!',
        });
        setShow(true);

        setTimeout(() => {
            setShow(false);
        }, 2000);
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleUploadClick = () => fileInputRef.current?.click();

    const handleClearImage = () => {
        setImage(null);
        setImagePreview(null);
    };

    
    const routeMapping = {
        'Contact details For User': "/contact-details/user",
        'Contact details For Staff': "/contact-details/staff",
        'Contact Details Office': "/contact-details/office",
    };



    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully Updated"}
            />
            <div className={styles.jobmanagementCotainer}>
                <div className={styles.jobtoppart}>
                    <div className={styles.pagetitle}>
                        <h6>Contact Details</h6>
                    </div>
                    <div className={styles.rightbuttons}>
                        <div className={styles.rightbuttons2} onClick={handleUpdate}>
                            {/* <FaPlus color='#FFFFFF' /> */}
                            <p>{loading ? "Updating..." : "Update Details"}</p>
                        </div>
                    </div>
                </div>
                <div className={styles.jobselectcontainer}>
                    <div className={styles.jobStatusContainer}>
                        {['Contact details For User','Contact details For Staff', 'Contact Details Office'].map((item, index) => (
                            <Link key={index} to={routeMapping[item]} className={styles.link}>
                                <p
                                    className={
                                        item === 'Contact details For User'
                                            ? styles.jobOptionTrueactive
                                            : styles.jobOptionnotactive
                                    }
                                >
                                    {item}
                                </p>
                            </Link>
                        ))}
                    </div>
                </div>
                {loading ? (
                    <div className={styles.loadingnormal}>
                        <img src={img2} alt="Loading" width={100} height={100} />
                    </div>
                ) : (
                    <div className={styles.jobchildcontainer}>
                        <div className={styles.addcontactdetails}>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">Title*</label>
                                <input
                                    type="text"
                                    placeholder='Enter the title'
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">Facebook*</label>
                                <input
                                    type="text"
                                    placeholder='Enter the facebook link'
                                    value={fb}
                                    onChange={(e) => setFB(e.target.value)}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">Instagram</label>
                                <input
                                    type="text"
                                    placeholder='Enter the instagram link'
                                    value={insta}
                                    onChange={(e) => setInsta(e.target.value)}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">LinkedIn*</label>
                                <input
                                    type="text"
                                    placeholder='Enter the linkedIn link'
                                    value={linkdin}
                                    onChange={(e) => setLinkdin(e.target.value)}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">X*</label>
                                <input
                                    type="text"
                                    placeholder='Enter the X link'
                                    value={twitter}
                                    onChange={(e) => setTwitter(e.target.value)}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">Mobile Number*</label>
                                <input
                                    type="text"
                                    placeholder='Enter the mobile number'
                                    value={mobilenumber}
                                    onChange={(e) => setMoileNumber(e.target.value)}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">Mobile Number Description*</label>
                                <input
                                    type="text"
                                    placeholder='Enter the mobile number description'
                                    value={mobilenumberdescription}
                                    onChange={(e) => setMobileDescription(e.target.value)}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">Email*</label>
                                <input
                                    type="email"
                                    placeholder='Enter the email'
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">Email Description*</label>
                                <input
                                    type="text"
                                    placeholder='Enter the email description'
                                    value={emaildescription}
                                    onChange={(e) => setEmailDescription(e.target.value)}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">whatAppchat Number*</label>
                                <input
                                    type="text"
                                    placeholder='Enter the whatAppchat number'
                                    value={whatsappnumber}
                                    onChange={(e) => setWhatsappNumeber(e.target.value)}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">WhatAppchat Description*</label>
                                <input
                                    type="text"
                                    placeholder='Enter the whatAppchat description'
                                    value={whatsappdescription}
                                    onChange={(e) => setWhatsappdescription(e.target.value)}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">Map*</label>
                                <input
                                    type="text"
                                    placeholder='Enter the map link'
                                    value={map}
                                    onChange={(e) => setMap(e.target.value)}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">Address*</label>
                                <input
                                    type="text"
                                    placeholder='Enter the address'
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                            </div>

                        </div>
                        <div className={styles.addjobinputs}>
                            <label htmlFor="">Description*</label>
                            <textarea
                                placeholder='Enter the description'
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </div>
                        <div className={styles.addbannercontainer}>
                            <label htmlFor="">Image*</label>
                            <div className={styles.addbannerinput}>
                                {imagePreview ? (
                                    <>
                                        <div className={styles.editbannerimage}>
                                            <img src={imagePreview} alt="" />
                                        </div>
                                        <span onClick={handleClearImage}>Clear</span>
                                    </>
                                ) : (
                                    <>
                                        <div className={styles.addbannerupload} onClick={handleUploadClick}>
                                            <RiImageAddLine color='#8D98AA' size={35} />
                                            <p>Upload your file</p>
                                        </div>
                                        <span>Max 2MB</span>
                                    </>
                                )}
                            </div>
                            <input
                                type="file"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                hidden
                            />
                        </div>
                    </div>
                )}
            </div >
        </>
    )
}

export default HOC(UserContactDetails)
